// me.QTRendererExt = null;//this single instance will get initialized on very 1st message of a Chat
import ManageFocusOnKeyEvents from '../core/hooks/ManageFocusOnKeyEvents';
import isLastMessage from '../core/hooks/isLastMessage';
import BaseClass from '../core/BaseClass';
import { ScriptsQuestionType } from '../core/enums/Enum';
import WidgetTypes from '../core/enums/WidgetTypes';
import RunAsSoonAs from '../core/hooks/RunAsSoonAs';
import observe from '../core/hooks/observe';
import isAcceptKey from '../core/hooks/isAcceptKey';
import hideElement from '../core/hooks/hideElement';

export default class QTMessageRenderer extends BaseClass {
    constructor(options) {
        super(options);
        const me = this;
        me.options = options;
        me.$ = options.$;
        me.context = options.context;
        me.updateCallback = options.updateCallback;
        // this is default renderer; we should set default props here which should/may work for all quick reply types
        me.model = options.msg;
        me.container = options.container;
        // me.container = me.$(options.container, me.context)[0];//container for all messages
        me.wrapper = options.wrapper; // container for this QR message
        me.type = me.model.questionType;
        // me.template = null;//parsed template
        me.selectOptions = [];
        me.updateButtonId = `apexchat-btn-update-${me.model.id}`;
        me.isFromPreChat = options.isFromPreChat;
    }

    // 1st render OR page reload: just parse & append template
    render() {
        // TODO: move templating stuff of renderMessage() here later
        const me = this;
    }

    // set selection AFTER 1st render OR page reload
    afterRender() {
        const me = this;
        me.wrapper.innerHTML = me.selectOptions
            ? me.template.replace('apexchat_options_div', me.selectOptions.innerHTML)
            : me.template;
        me.container.appendChild(me.wrapper);
    }

    displaySkipOption() {
        const me = this;
        const isSkippable =
            me.model.isSkippable ||
            (me.model.agentScript ? me.model.agentScript.isSkippable : false);
        // show skip button when isSkippable true
        if (isSkippable) { // show skip button when isSkippable true 
            const skipButton = me.context.getElementById(`apexchat_skip_question_${me.model.id}`);
            if (isLastMessage(me.model)) {
                // this condition handle refresh case
                RunAsSoonAs(
                    () => {
                        ManageFocusOnKeyEvents(skipButton);
                        // scroll down when skip question visible
                        if (
                            me.options.msg &&
                            me.options.msg.questionType ==
                            ScriptsQuestionType.AppointmentScheduler
                        ) {
                            me.config.onAutoScroll();
                        }
                    },
                    () => {
                        skipButton?.style.display = 'block';
                        return skipButton?.style.display !== 'none';
                    }
                );
            } else {
                hideElement(skipButton); // hide skip button
            }

        }
    }

    // UI changes after selection
    onSelection() { }

    bindUpdateClick() {
        const me = this;
        const updateButton = me.context.getElementById(me.updateButtonId);
        if (updateButton) {
            observe(updateButton, 'click', (e) => {
                me.onUpdateEvent.bind2(me, e, me.model, me.updateClickHandler)();
            });
            // apply ADA
            observe(updateButton, 'keyup', (e) => {
                if (isAcceptKey(e)) {
                    me.onUpdateEvent.bind2(me, e, me.model, me.updateClickHandler)();
                } else {
                    // ApexChat.manageFocus(e, this);
                }
            });
        }
    }

    onUpdateEvent() { }

    manageQtFocus(e, options) {
        const me = this;
        const doOnAcceptKey =
            options && options.onAccept
                ? options.onAccept
                : function () {
                    /* do nothing */
                };
        if (isAcceptKey(e)) {
            if (!options.context.$(this, options.context.context).isDisabled()) {
                // if element is disabled it should not work using keyboard
                options.isNotSend
                    ? doOnAcceptKey.bind2(me, e, options)()
                    : options.context[options.eventType](e, options.msg, options.text);
                options.context.$(this, options.context.context).blur();
                // we prevent vox to read element.
                options.context.muteAllElements(options);
                setTimeout(() => {
                    // we enabled vox to read element.
                    options.context.unmuteAllElements(options);
                }, 500);
            }
        }
        // else {
        //    ApexChat.manageFocus(e, this);
        // }
    }

    muteAllElements(options) {
        for (let i = 0; i < options.muteElements.length; i++) {
            options.context
                .$(options.muteElements[i], options.context.context)
                .attr('aria-hidden', true);
        }
    }

    /*
        Using this function we enabled vox to read element. 
     */
    unmuteAllElements(options) {
        for (let i = 0; i < options.muteElements.length; i++) {
            options.context
                .$(options.muteElements[i], options.context.context)
                .attr('aria-hidden', false);
        }
    }

    setDisabled() { }

    isPreChatOrVideoGreet() {
        const me = this;
        const widgetType =
            me.options.widgetType == WidgetTypes.PreChat ||
            me.options.widgetType == WidgetTypes.VideoGreetInvitation;
        if (widgetType) {
            return true;
        }
        return false;
    }
}
